import { Box, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from 'recharts';

export type TimeParticipationDatum = {
  timeRange: string;
  value: number;
};

const BAR_COLOR_DEFAULT = '#DCDCDC';
/** 1~3순위 바 색상 */
const RANK_COLORS = ['#60A5FA', '#93C5FD', '#BFDBFE'] as const;

type Props = {
  data?: TimeParticipationDatum[];
};

export default function RouletteContentTimeParticipationChart({ data }: Props) {
  const chartData = data ?? [];
  const maxValue = chartData.length ? Math.max(...chartData.map((d) => d.value), 1) : 1;
  const topThreeRanges = [...chartData]
    .sort((a, b) => b.value - a.value)
    .slice(0, 3)
    .map((d) => d.timeRange);

  const getBarColor = (timeRange: string) => {
    const rank = topThreeRanges.indexOf(timeRange);
    if (rank >= 0 && rank < 3) return RANK_COLORS[rank];
    return BAR_COLOR_DEFAULT;
  };

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderRadius: 3,
        p: 2,
      }}
    >
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={1.5}
        color="#475569"
        textAlign="center"
        sx={{ fontSize: '0.95rem' }}
      >
        시간대별 참여 현황
      </Typography>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={chartData} margin={{ top: 20, right: 16, left: 4, bottom: 4 }}>
          <XAxis
            dataKey="timeRange"
            tick={{ fontSize: 10 }}
            axisLine={{ stroke: '#e0e0e0' }}
            tickLine={false}
          />
          <YAxis hide domain={[0, maxValue * 1.1]} />
          <Bar
            dataKey="value"
            radius={[4, 4, 0, 0]}
            maxBarSize={32}
            isAnimationActive={false}
            label={{
              position: 'top',
              fontSize: 10,
              fill: '#000',
              formatter: (v: number) => v.toLocaleString('ko-KR'),
            }}
          >
            {chartData.map((entry) => (
              <Cell key={entry.timeRange} fill={getBarColor(entry.timeRange)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
